// @ts-nocheck
/* eslint-disable */
export const appQuantityIcon = {
    data: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="m29.068 21.001 41.516 41.516-41.516 41.525v74.957h112.25l44.025-44.025v-72.457l-41.525-41.516zm43.584 46.957h102.24l-33.582 33.584h-68.662zm107.69 2.0586v62.457l-36.525 36.525v-62.457zm-146.27 36.525h104.75v67.457h-104.75z"/></svg>`,
    name: 'quantity' as const
};